<template>
  <div>
    <div
      :style="{ height: `${MENU_BAR_HEIGHT}px` }"
      class="bg-blue-darken-4"
    ></div>
    <v-container class="mb-16" style="margin-top: 37px">
      <v-row>
        <v-col>
          <div>
            <h1 class="text-h2 mb-4">
              Sorry, we're unable to locate that workshop.
            </h1>
            <p class="text-body-1 mb-4">
              The workshop you're looking for isn't available. Please explore
              our current workshop offerings for upcoming sessions.
            </p>
            <v-btn
              color="red-darken-2"
              href="/training/workshops"
              rounded="pill"
              variant="flat"
              >Browse Workshops</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>

    <DividerSection class="mb-16" />
  </div>
</template>

<script setup>
import { MENU_BAR_HEIGHT } from '#root/lib/consts'
</script>
